import { isObject, isString } from 'radash';

export const success = 'Success';
export type Success = typeof success;
export type Reason = Error | string;
export type SyncResult = Success | Failed;

export interface Failed {
  failure: Reason;
}

export function isError(obj: unknown): obj is Error {
  // isObject does _not_ return true for an Error,
  // even though `typeof` does return `object`.
  if (typeof obj !== 'object') return false;
  return isString((obj as Partial<Error>).message);
}

export function isReason(obj: unknown): obj is Reason {
  return isError(obj) || isString(obj);
}

export function isFailed(obj: unknown): obj is Failed {
  if (!isObject(obj)) return false;
  const possible = obj as Partial<Failed>;
  return isReason(possible.failure);
}

export function toFailed(obj: unknown): Failed {
  if (isFailed(obj)) {
    return obj;
  }

  const reason: Reason = isReason(obj) ? obj : `Unknown Error During Sync: ${obj}`;
  const failed: Failed = {
    failure: reason,
  };
  return failed;
}

export function isSyncResult(obj: unknown): obj is SyncResult {
  if (obj === success) return true;
  if (isFailed(obj)) return true;
  return false;
}
